<template>
  <v-row>
    <v-col cols="12" sm="12" md="4">
      <email-opt />
    </v-col>
    <v-col cols="12" sm="12" md="4">
      <access-to-records />
    </v-col>
    <v-col cols="12" sm="12" md="4">
      <request-profile-remove />
    </v-col>
    <v-col cols="12" sm="12">
      <v-row>
        <v-col cols="12" sm="12">
          <my-data-request />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import EmailOpt from '@/components/Profile/Privacy/EmailOpt'
import AccessToRecords from '@/components/Profile/Privacy/AccessToRecords'
import RequestProfileRemove from '@/components/Profile/Privacy/RequestProfileRemove'
import MyDataRequest from '@/components/Profile/Privacy/MyDataRequest'
import { mapGetters } from 'vuex'
import { eu_countries } from 'Helpers/countries'

export default {
  name: 'ProfilePrivacy',
  components: {
    EmailOpt, AccessToRecords, RequestProfileRemove, MyDataRequest
  },
  computed: {
    ...mapGetters(['SessionProfile']),
    /**
     * Check if customer from EU countries.
     * @returns {boolean}
     */
    isCustomerFromEU () {
      const search = eu_countries.find(item => item.code === this.SessionProfile.country)

      return search !== undefined
    }
  }
}
</script>
